import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { usePfStore } from '../store'
import { pfSessionBase, usePfBasePath, usePfRootPath, usePfUrlSessionId } from './pfBasePath'

/**
 * Keeps the flow URL naming the current purchase session, so a reload can find the order again. A URL without the
 * segment (a plain link, an absolute in-app navigation) gains it, and a session the flow replaced is swapped in;
 * the step, query and navigation state are kept.
 */
export const usePfSessionUrl = (): void => {
  const navigate = useNavigate()
  const location = useLocation()
  const root = usePfRootPath()
  const base = usePfBasePath()
  const urlSessionId = usePfUrlSessionId()
  const sessionId = usePfStore((s) => s.draft.sessionId)

  useEffect(() => {
    if (!sessionId || sessionId === urlSessionId) return
    if (!location.pathname.startsWith(base)) return
    const rest = location.pathname.slice(base.length)
    navigate(`${pfSessionBase(root, sessionId)}${rest}${location.search}${location.hash}`, { replace: true, state: location.state })
  }, [sessionId, urlSessionId, base, root, location, navigate])
}
